import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { apiResources } from '../api/api.resources';
import { BillingServiceInterface } from './billing.service.interface';
import { BillingResponse, AddPaymentMethodPayload, PaymentMethodsResponse, InvoicesResponse, PayInvoiceResponse, PlansResponse, UpdateSubscriptionPayload, UpdateSubscriptionResponse, ChargesResponse } from './billing.type';
import { environment } from '../../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class BillingService implements BillingServiceInterface {

    constructor(
        private _httpClient: HttpClient
    ) {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Get subscription data
     */
    getSubscription(): Observable<BillingResponse> {
        return this._httpClient.get<BillingResponse>(
            environment.config.apiUrl +
            apiResources.v1 +
            apiResources.billing.base +
            apiResources.billing.subscription
        );
    }

    /**
     * Add payment method
     */
    addPaymentMethod(payload: AddPaymentMethodPayload): Observable<any> {
        return this._httpClient.post(
            environment.config.apiUrl +
            apiResources.v1 +
            apiResources.billing.base +
            apiResources.billing.paymentMethods,
            payload
        );
    }

    /**
     * Get payment methods
     */
    getPaymentMethods(): Observable<PaymentMethodsResponse> {
        return this._httpClient.get<PaymentMethodsResponse>(
            environment.config.apiUrl +
            apiResources.v1 +
            apiResources.billing.base +
            apiResources.billing.paymentMethods
        );
    }

    /**
     * Delete payment method
     */
    deletePaymentMethod(paymentMethodId: string): Observable<any> {
        return this._httpClient.delete(
            environment.config.apiUrl +
            apiResources.v1 +
            apiResources.billing.base +
            apiResources.billing.paymentMethods +
            '/' + paymentMethodId
        );
    }

    /**
     * Get invoices
     */
    getInvoices(): Observable<InvoicesResponse> {
        return this._httpClient.get<InvoicesResponse>(
            environment.config.apiUrl +
            apiResources.v1 +
            apiResources.billing.base +
            apiResources.billing.invoices
        );
    }

    /**
     * Get charges (receipts)
     */
    getCharges(): Observable<ChargesResponse> {
        return this._httpClient.get<ChargesResponse>(
            environment.config.apiUrl +
            apiResources.v1 +
            apiResources.billing.base +
            apiResources.billing.charges
        );
    }

    /**
     * Pay invoice with boleto or pix
     */
    payInvoice(invoiceId: string, paymentMethod: 'boleto' | 'pix'): Observable<PayInvoiceResponse> {
        return this._httpClient.post<PayInvoiceResponse>(
            environment.config.apiUrl +
            apiResources.v1 +
            apiResources.billing.base +
            apiResources.billing.invoices +
            '/' + invoiceId +
            '/pay',
            { payment_method: paymentMethod }
        );
    }

    /**
     * Get available plans
     */
    getPlans(): Observable<PlansResponse> {
        return this._httpClient.get<PlansResponse>(
            environment.config.apiUrl +
            apiResources.v1 +
            apiResources.billing.base +
            apiResources.billing.plans
        );
    }

    /**
     * Update subscription plan
     */
    updateSubscription(payload: UpdateSubscriptionPayload): Observable<UpdateSubscriptionResponse> {
        return this._httpClient.put<UpdateSubscriptionResponse>(
            environment.config.apiUrl +
            apiResources.v1 +
            apiResources.billing.base +
            apiResources.billing.subscription,
            payload
        );
    }
}
